import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import { BoxValidations } from "@boxes/BoxValidations";
import style from "@styles/pages/flow/boxes/Box.module.scss";
import classnames from "classnames/bind";
import { memo } from "react";
import SourceBaseBox from "../layout/SourceBaseBox";

const events = {
  CUSTOMER_REGISTER: "Cadastro",
  FIRST_ORDER: "Primeiro pedido",
};

export default memo(({ data, selected, isConnectable }) => {
  const cx = classnames.bind(style);

  return (
    <SourceBaseBox
      valid={BoxValidations.validate(BoxTypes.EventSource, data)}
      title={BoxTitles.EventSource}
      selected={selected}
      isConnectable={isConnectable}
    >
      {data.eventType && (
        <div className={style.subline}>{events[data.eventType]}</div>
      )}
    </SourceBaseBox>
  );
});
